import React from 'react'
import PropTypes from 'prop-types'
import { flowRight } from 'lodash'
import { useTranslation } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { useMutation } from '@apollo/client'
import { useLocation, useHistory } from 'react-router-dom'
import { getPrimaryLocation } from 'lib/location'
import { isProductionHost } from 'lib/env'
import { getLocale } from 'lib/utils/getLocale'

import Button from 'components/UI/Button'
import ErrorComponent from 'components/Errors/ErrorComponent'

import getBoardingUrlMutation from 'graphql/user/getBoardingUrl.gql'

const UserIdentification = ({ context }) => {
    const location = useLocation()
    const history = useHistory()
    const primaryLocation = getPrimaryLocation(location)
    const { t, i18n } = useTranslation('user')

    const [getBoardingUrl, { loading: getBoardingUrlLoading, error: getBoardingUrlError }] = useMutation(getBoardingUrlMutation)

    const redirectToPgwBoardingUrl = () => {
        if (isProductionHost()) {
            getBoardingUrl({
                variables: {
                    successTarget: primaryLocation.pathname + primaryLocation.search,
                    failureTarget: primaryLocation.pathname
                }
            }).then((result) => {
                window.location.href = result.data.getBoardingUrl
            })
        } else {
            history.push({
                pathname: `${getLocale(i18n.language)}/dev/user-identification-test-data-input`,
                state: {
                    successTarget: primaryLocation.pathname + primaryLocation.search,
                    failureTarget: primaryLocation.pathname
                }
            })
        }
    }

    return (
        <div className="user-identification">
            <div>
                <p>
                    {t(`user:userIdentification.context.${context}.description`)}
                </p>
            </div>
            <div className="action-wrapper">
                <Button
                    className="button"
                    trackName="startPgwIdentification"
                    onClick={redirectToPgwBoardingUrl}
                    loading={getBoardingUrlLoading}
                    disabled={getBoardingUrlLoading}
                >
                    {t('user:userIdentification.submit')}
                </Button>
            </div>
            {getBoardingUrlError && <ErrorComponent error={getBoardingUrlError} />}
        </div>
    )
}

UserIdentification.propTypes = {
    context: PropTypes.oneOf(['bos-documents']).isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender,
)(UserIdentification)
